import React from "react";

// Import your images properly
import img1 from "../../assets/images/ft.jpg";
import img2 from "../../assets/images/bg.jpg";
import img3 from "../../assets/images/pt.jpg";
import img4 from "../../assets/images/ra.jpg";
import img5 from "../../assets/images/pt4.jpg";

// =====================
// Single Portfolio Item (Glass + Neon)
// =====================
function PortfolioItem({ heightClass, imageSrc, altText }) {
  return (
    <div
      className={`relative rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.03] ${heightClass}`}
      style={{
        background: "rgba(255,255,255,0.04)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(0,245,160,0.25)",
        boxShadow: "0 0 25px rgba(0,245,160,0.15)",
      }}
    >
      {/* Image */}
      <img
        src={imageSrc}
        alt={altText || "Portfolio Item"}
        className="w-full h-full object-cover"
      />

      {/* Neon Overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          boxShadow: "0 0 30px rgba(0,245,160,0.4)",
          border: "1px solid rgba(0,245,160,0.25)",
          borderRadius: "16px",
        }}
      />
    </div>
  );
}

export default function Uidesign() {
  const gradientText = {
    background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-20 text-white relative bg-[#0B0E11]">
      {/* Heading – Mobile */}
      <h2
        className="text-4xl font-extrabold mb-10 text-center lg:hidden"
        style={gradientText}
      >
        DESIGNING
      </h2>

      {/* Heading – Desktop Vertical */}
     {/* Heading – Desktop Vertical */}
<h2
  className="hidden lg:block absolute top-2/3  left-0 -translate-y-1/2 text-6xl font-extrabold tracking-wide"
  style={{
    ...gradientText,
    transform: "rotate(-90deg) translateY(50%)", // rotate and nudge to center
    transformOrigin: "left center",
  }}
>
  DESIGNING
</h2>


      {/* Portfolio Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {/* Column 1 */}
        <div className="flex flex-col gap-8">
          <PortfolioItem heightClass="h-44 sm:h-56" imageSrc={img1} />
          <PortfolioItem heightClass="h-44 sm:h-56" imageSrc={img2} />
        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-8">
          <PortfolioItem heightClass="h-36 sm:h-48" imageSrc={img3} />
          <PortfolioItem heightClass="h-48 sm:h-60" imageSrc={img4} />
        </div>

        {/* Column 3 */}
        <div className="flex flex-col gap-8">
          {/* Make 3rd column taller */}
          <PortfolioItem heightClass="h-96 sm:h-[28rem]" imageSrc={img5} />
        </div>
      </div>

      {/* Description */}
      <p className="mt-14 text-center text-white/70 max-w-3xl mx-auto">
        Your visual identity defines how the world sees your brand. We craft bold,
        creative, and meaningful designs — from branding to social media creatives —
        that help your business stand out with confidence and clarity.
      </p>

      {/* CTA */}
      <div className="mt-6 text-center">
        <button className="font-semibold text-[#00F5A0] hover:underline">
          Show More
        </button>
      </div>
    </section>
  );
}
